<template>
  <el-aside class="asideCon" :class="{'active':toggleFlag}">
    <div class="tab-hover" @mouseenter="menuUp($event)" @mouseleave="menuDown($event)">
      <span>
        <i :class="`el-icon-menu`"></i>
        全部菜单
      </span>
      <div class="tab-whole" v-if="menuLists" :class="{'tab-whole-small': toggleFlag}">
        <div class="tab-div">
          <img src="./img/search.png"/>
          <input class="tab-search" type="text" @input="searchMenu" placeholder="请输入子菜单进行搜索" v-model="menuName"/>
        </div>
        <div class="tab-cole">
          <ul class="tab-ul" v-for="(menu,index) in lists" v-if="menu.children.length > 0">
            <li class="tab-li">
              <p style="display:flex;align-items:center">
                <svg class="icon-svg" aria-hidden="true" style="color:#fff;margin-right:5px;"><use :xlink:href="`#${menu.icon}`"></use></svg>
                {{menu.name}}
              </p>
              <ul class="tab-child-ul">
                <li v-for="(sub,subIndex) in menu.children" @click.exact="handleMenuClick(sub, $event)" class="tab-child-li"
                    @click.alt.exact="setShortcutKey(sub.routeUrl, $event)">
                  {{sub.name}}
                  <el-badge :value="sub.hotKey" style="position: absolute; right: -22px; top: 6px;"></el-badge>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <ul class="tab" v-if="menuLists">
      <template v-for="(menu,index) in menuLists">
        <li class="menu-children" :class="shouldHighlightMenuAt(index) ? 'active' : ''"
          @mouseenter="setActiveIndex($event, index)"
          @mouseleave="clearActiveIndex($event, index)"
          @click="handleMenuClick1(menu)"
        >
          <div class="tab-btn">
            <svg :class="`el-${menu.icon} tab-icon icon-svg ${mouseEnter ? 'tab-active' : '',shouldHighlightMenuAt(index) ? 'active' : ''}`" aria-hidden="true"><use :xlink:href="`#${menu.icon}`"></use></svg>
              <span class="tab-text" :class="`${mouseEnter ? 'tab-active' : '',shouldHighlightMenuAt(index) ? 'active' : ''}`">{{menu.name}}</span>
              <div class="menu-children-ul clearfix" v-if="menu.children.length >= 1" :class="{'ul-small':toggleFlag}">
                <ul class="children">
                  <div class="children-div">
                    <span
                      :class="{'tab-active':mouseEnter,active:shouldHighlightMenuAt(index)}" v-html="menu.name"></span>
                  </div>
                  <li class="menu-children-li"
                      v-for="(subMenu,subIndex) in menu.children"
                      @click="handleMenuClick(subMenu)"
                      v-html="subMenu.name"
                    >
                  </li>
                </ul>
              </div>
          </div>
        </li>
      </template>
    </ul>
    <div class="aside-up">
      <strong class="aside-up-img" @click="toggle" :class="{'up-active':toggleFlag}"></strong>
    </div>
  </el-aside>
</template>

<script>
import ArrayUtils from "../../utils/ArrayUtils";
import DataUtils from "../../utils/DataUtils";
import {mapActions, mapState, mapMutations} from "vuex";
import _ from "../../utils/ObjectUtils";
  export default {
    data() {
      return {
        mouseEnter:false,
        menuName:'',
        searchList:[],
        menuLists:[],
        lists:[],
        //鼠标滑过的菜单Index
        hoverMenuIndex: -1,
        activeMenuIndex: -1,// 当前激活的菜单Id
      }
    },
    created () {
      this.updateMenu();
    },
    computed:{
      ...mapState([
        'toggleFlag'
      ])
    },
    methods: {
      ...mapMutations([
        'setToggleFlag'
      ]),
      // 菜单样式切换
      toggle(){
        console.log(this.toggleFlag)
        this.setToggleFlag(!this.toggleFlag);
      },
      updateActiveMenuIndex() {
        console.log(this.$route)
        var pid = ArrayUtils.getItemBy(window.SITE_CONFIG['dynamicMenuRoutes'], 'path', this.$route.name).meta.pid
        var name =  ArrayUtils.getItemBy(this.menuLists, 'id', pid).name
        this.activeMenuIndex = ArrayUtils.getItemIndex(this.menuLists, 'name', name)
      },
      // 菜单跳转
      handleMenuClick(row){
        // 通过menuId与动态(菜单)路由进行匹配跳转至指定路由
          var route = window.SITE_CONFIG['dynamicMenuRoutes'].filter(item => item.meta.menuId === row.id)[0]
          var name =  ArrayUtils.getItemBy(this.menuLists, 'id', row.pid).name
          this.activeMenuIndex = ArrayUtils.getItemIndex(this.menuLists, 'name', name)
          if(row.name == '演示视频' || row.name == '操作手册'){
            return this.$message.error('暂未开放!',1500);
          }
          if (route) {
            this.$router.push({ name: route.name })
          }
      },
      handleMenuClick1(row){
        if(row.name == '首页'){
          var route = window.SITE_CONFIG['dynamicMenuRoutes'].filter(item => item.meta.menuId === row.id)[0]
          this.activeMenuIndex = 0
          this.$router.push({ name: route.name })
        }
      },
      // 鼠标移入
      menuUp(e) {
        let thisDom = e.target;
        this.isAllMenu = true;
        thisDom.querySelector('.tab-whole').style.width = "840px";
      },
      // 鼠标移出
      menuDown(e) {
        let thisDom = e.target;
        this.isAllMenu = false;
        thisDom.querySelector('.tab-whole').style.width = "0";
        this.menuName = '';
        this.lists = _.cloneDeep(this.menuLists);
      },
      // 模糊搜索
      searchMenu() {
        //输入菜单名称进行搜索
        if(this.menuName) {
          let searchList = new Map();
          for(var i = 0; i < this.menuLists.length; i++) {
            this.searchList[i].children = [];
            for(var j = 0; j < this.menuLists[i].children.length; j++) {
              let b = this.menuLists[i].children[j].name;
              if(b.indexOf(this.menuName) != -1) {
                this.searchList[i].children.push(this.menuLists[i].children[j]);
                searchList.set(this.searchList[i]);
              }
            }
          }
          this.lists = [...searchList.keys()];
        }else {
          this.lists = _.cloneDeep(this.menuLists);
        }
      },
      // 初始化菜单数据
      updateMenu() {
        this.$nextTick(() =>  {
          this.menuLists = window.SITE_CONFIG['menuList'];
          this.searchList = _.cloneDeep(this.menuLists);
          this.lists = _.cloneDeep(this.menuLists);
          this.updateActiveMenuIndex();
        })
      },
      setActiveIndex(e, menuIndex) {
        this.hoverMenuIndex = menuIndex;
        let menu = this.menuLists[menuIndex];
        menu.shrink = true;
        let thisDom = e.target;
        if(thisDom.querySelector('.menu-children-ul')){
          thisDom.querySelector('.menu-children-ul').style.display = "block";
        }
        let thisDomLen = thisDom.querySelectorAll('.menu-children-li').length;
        if(thisDomLen > 14) {
          thisDom.querySelector('.menu-children-ul').style.width = '320px';
        }
      },
      clearActiveIndex(e, menuIndex) {
        if (menuIndex !== this.activeMenuIndex) {
          this.hoverMenuIndex = -1;
        }
        let menu = this.menuLists[menuIndex];
        menu.shrink = false;
        let thisDom = e.target;
        if(thisDom.querySelector('.menu-children-ul')) {
          thisDom.querySelector('.menu-children-ul').style.display = "none";
        }
      },
      shouldHighlightMenuAt(menuIndex) {
        return this.activeMenuIndex === menuIndex || this.hoverMenuIndex === menuIndex;
      },
    },
  }
</script>

<style lang="scss">
.asideCon{
  // background: #202d4d;
  background:linear-gradient(180deg,#385fc7,#2e47b2);
  position: relative;
  transition: .3s;
  width: 180px !important;
  &.active{
    width: 52px !important;
  }
  overflow: inherit
}
@import "./index.scss";
</style>
